export default __webpack_public_path__ + "static/media/jaggedcut3.c6729d60.png";